// generated from 31_924 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const hasEmailFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("has_email_filter"),
  comparison_key: z.literal("1"),
  display_name: z.string(),
  // undefined: 9_777 (30.63%), defined 22_147 (69.37%)
  // true 21_027 (94.94%), false 1_120 (5.06%)
  raw_value: z.boolean().optional(),
  // true 30_169 (94.50%), false 1_755 (5.50%)
  value: z.boolean(),
  varies_by_app_group: z.literal(false),
});
